import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiError } from '../shared/enums/api-error.enum';
import { BalanceService } from './balance.service';

@Injectable({
  providedIn: 'root'
})
export class SaldoCedenteService {

  private messageSource = new BehaviorSubject(0);
  public saldoAtual = this.messageSource.asObservable();

  constructor(private balanceService: BalanceService) { }

  public updateBalance(assignorGuid: string){
    this.balanceService
    .getTotalBalanceAvailable(assignorGuid)
    .toPromise().then(response => {
        if (response.status === ApiError.Sucesso) {
          this.messageSource.next(response.result);
          this.balanceService.setCurrentBalanceValue(response.result);
        }
    });
  }

  public updateCurrentAccountBalance(assignorGuid: string){
    this.balanceService
    .getCurrentAccountBalance(assignorGuid)
    .toPromise().then(response => {
        if (response.status === ApiError.Sucesso) {
            this.balanceService.setCurrentAccountBalanceValue(response.result);
        }
    });
  }

}
